"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpgradeButtonText = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _getProductNameText = require("ui-addon-upgrades/_core/common/adapters/getProductNameText");

var _upgradeProducts = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts");

var _getButtonText = function _getButtonText(i18nKey, productTitle) {
  return _I18n.default.text("upgrades.upgradeButton." + i18nKey, {
    productTitle: productTitle
  });
};
/**
 * @param {string} upgradeType
 * @param {string} upgradeProduct
 * @return {string}
 */


var getUpgradeButtonText = function getUpgradeButtonText(upgradeType, upgradeProduct) {
  if (upgradeProduct === _upgradeProducts.upgradeProducts.GENERAL) return _I18n.default.text('upgrades.upgradeButton.default');
  var productTitle = (0, _getProductNameText.getProductNameText)(upgradeProduct);
  return _getButtonText(upgradeType, productTitle);
};

exports.getUpgradeButtonText = getUpgradeButtonText;